import { DirectionsCarFilled, ListAlt } from '@mui/icons-material';
import { Button, ButtonGroup } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setAllOrdersSortDetails } from '../../../redux/actions/workQueue/allOrdersActions';
import {
  ORDERS_VIEW,
  VEHICLE_VIEW,
  useViewOrdersOrVehicle,
} from '../ViewOrdersOrVehicle.provider';

export default function ToggleViewButtons() {
  const { view, setView } = useViewOrdersOrVehicle();
  const dispatch = useDispatch();

  const activeSx = {
    px: 0,
    py: 1,
    borderColor: theme => theme.palette.divider,
    backgroundColor: 'rgba(0, 125, 255, 0.09)',
  };
  const inactiveSx = {
    px: 0,
    py: 1,
    color: theme => theme.palette.action.active,
    borderColor: theme => theme.palette.divider,
    backgroundColor: theme => theme.palette.background.paper,
  };

  return (
    <ButtonGroup>
      <Button
        sx={(view === ORDERS_VIEW && activeSx) || inactiveSx}
        onClick={() => {
          dispatch(
            setAllOrdersSortDetails({
              sortEnabled: false,
            })
          );
          setView(ORDERS_VIEW);
        }}
      >
        <ListAlt fontSize="small" />
      </Button>
      <Button
        sx={(view === VEHICLE_VIEW && activeSx) || inactiveSx}
        onClick={() => {
          dispatch(
            setAllOrdersSortDetails({
              sortEnabled: false,
            })
          );
          setView(VEHICLE_VIEW);
        }}
      >
        <DirectionsCarFilled fontSize="small" />
      </Button>
    </ButtonGroup>
  );
}
